import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import { EmployeeGovtIdDetailsState, employeeGovtIdDetailsKey } from '../reducers/employee-govt-id-details.reducer';
import * as employeeGovtIdDetailsState from '../reducers/employee-govt-id-details.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, EmployeeGovtIdDetailsState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Employee lock SUB STATE
export const getEmployeeGovtIdDetailsState = createSelector(getMainEmployeeState, state => state[employeeGovtIdDetailsKey]);
//#endregion

//#region Employee lock SUB STATE
export const getEmployeeGovtIdDetailsRequest = createSelector(getEmployeeGovtIdDetailsState, employeeGovtIdDetailsState.getEmployeeGovtIdDetailsRequest);
export const getEmployeeGovtIdDetailsResponse = createSelector(getEmployeeGovtIdDetailsState, employeeGovtIdDetailsState.getEmployeeGovtIdDetailsResponse);
export const getEmployeeGovtIdDetailsFailure = createSelector(getEmployeeGovtIdDetailsState, employeeGovtIdDetailsState.getEmployeeGovtIdDetailsFailure);
//#endregion
